import * as React from "react";
import TableOfContents from "../../components/table-of-contents";
import { IMAGE_BASE_URL } from "../../data/baseURL";
import { ourValueAndApproachSubMenu } from "../../data/our-value-and-approach-submenu";
import { useScrollTop } from "../../hook/useScrollTop";
// import bannerImg from "../../images/our-values-and-approach/content-fullwidth-10.jpg";
import Excellence from "../../sections/excellence";
import Partnership from "../../sections/partnership";
import { AboutDataContext } from "./about";

const OurValueAndApproach = () => {
  const { about_approach_banner, about_approach_integrity } =
    React.useContext(AboutDataContext);

  useScrollTop();
  return (
    <>
      <section className="d-none d-lg-block">
        <ul className="row fs-14 bg-light list-style-none text-center gilroy-bold m-0 p-0">
          {ourValueAndApproachSubMenu.map((menu) => (
            <li key={menu.label} className="col-4 border-gray submenu-link">
              <a
                href={menu.link}
                className="text-decoration-none text-orange-ryb py-4 d-block"
              >
                {menu.label}
              </a>
            </li>
          ))}
        </ul>
      </section>
      <TableOfContents routes={ourValueAndApproachSubMenu} />
      <section className="ms-35 me-35 mt-7">
        <div className="pb-5 border-bottom">
          <div className="my-5">
            <img
              src={`${IMAGE_BASE_URL}/${about_approach_banner.image}`}
              alt="banner img"
              className="img-fluid"
              loading="lazy"
            />
          </div>

          <h2 className="fs-24">{about_approach_banner.title}</h2>
          <p
            className="fs-16"
            dangerouslySetInnerHTML={{
              __html: about_approach_banner.description,
            }}
          />
        </div>
        <div className="py-5 border-bottom" id="integrity">
          <div className="row my-5">
            <div className="col-12 col-md-4">
              <img
                src={`${IMAGE_BASE_URL}/${about_approach_integrity.image}`}
                alt="integrity"
                className="img-fluid d-block  mx-auto ms-md-auto mb-4"
                loading="lazy"
              />
            </div>
            <div className="col-12 col-md-8">
              <h2 className="fs-30">{about_approach_integrity.title}</h2>
              <h3 className="fs-24">{about_approach_integrity.heading}</h3>
            </div>
          </div>
          <p
            className="fs-16"
            dangerouslySetInnerHTML={{
              __html: about_approach_integrity.description,
            }}
          />
          {/* <div>
            <LinkButton
              text={about_approach_integrity.button_text}
              icon="&rarr;"
              path=""
            />
            <a
              className="fs-16 text-decoration-none btn-key-company d-inline-block cursor-pointer"
              href={about_approach_integrity?.button_link}
              target="_blank"
              rel="noreferrer"
            >
              <span className="text-spanish-gray">&rarr;</span>
              {"  "}
              <span className="gilroy-bold text-orange-ryb">
                {about_approach_integrity?.button_text}
              </span>
            </a>
          </div> */}
        </div>
        <Partnership />
        <Excellence />
      </section>
    </>
  );
};

export default OurValueAndApproach;
